import React from 'react';

export default function Intro() {
  return (
    <section className="intro" id="approach" aria-labelledby="intro-heading">
      <div className="intro-content">
        <span className="eyebrow reveal">Our approach</span>
        <h2 id="intro-heading" className="reveal">
          Berthoud has always been a place where things grow well.
        </h2>
        <p className="lede reveal">
          Built on agricultural heritage, strong community ties, and a shared pride in calling this place home,
          Berthoud has long rewarded patience and care. As the town grows, residents and leaders want the same thing:
          development that strengthens the community rather than reshapes it into something unrecognizable.
        </p>
        <p className="reveal">
          We live here too. We care about this town not just as developers, but as neighbors who understand the
          importance of preserving Berthoud&rsquo;s character while planning for its future. That&rsquo;s why our work begins
          where it matters most: with the community itself.
        </p>
        <p className="closer reveal">We don&rsquo;t build to stand out. We build to belong.</p>
      </div>
    </section>
  );
}
